import { Injectable, inject } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { of } from 'rxjs'
import { map, switchMap, catchError } from 'rxjs/operators'
import { EmailProposalActions } from '../actions/email-proposal.actions'
import { EmailProposalMockService } from '../../services/email-proposal-mock.service'

@Injectable()
export class EmailProposalEffects {
    private actions$ = inject(Actions)
    private mockService = inject(EmailProposalMockService)

    loadProposalData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(EmailProposalActions.loadProposalData),
            switchMap(({ proposalId }) =>
                this.mockService.loadProposalData(proposalId).pipe(
                    map((proposalData) =>
                        EmailProposalActions.loadProposalDataSuccess({ proposalData }),
                    ),
                    catchError((error) =>
                        of(EmailProposalActions.loadProposalDataFailure({ error: error.message })),
                    ),
                ),
            ),
        ),
    )

    loadDocuments$ = createEffect(() =>
        this.actions$.pipe(
            ofType(EmailProposalActions.loadDocuments),
            switchMap(({ proposalId }) =>
                this.mockService.loadDocuments(proposalId).pipe(
                    map((documents) => EmailProposalActions.loadDocumentsSuccess({ documents })),
                    catchError((error) =>
                        of(EmailProposalActions.loadProposalDataFailure({ error: error.message })),
                    ),
                ),
            ),
        ),
    )

    loadEmailTemplates$ = createEffect(() =>
        this.actions$.pipe(
            ofType(EmailProposalActions.loadEmailTemplates),
            switchMap(() =>
                this.mockService.loadEmailTemplates().pipe(
                    map((templates) =>
                        EmailProposalActions.loadEmailTemplatesSuccess({ templates }),
                    ),
                    catchError((error) =>
                        of(EmailProposalActions.loadProposalDataFailure({ error: error.message })),
                    ),
                ),
            ),
        ),
    )

    sendEmail$ = createEffect(() =>
        this.actions$.pipe(
            ofType(EmailProposalActions.sendEmail),
            switchMap(() =>
                this.mockService.sendEmail().pipe(
                    map(() => EmailProposalActions.sendEmailSuccess()),
                    catchError((error) =>
                        of(EmailProposalActions.sendEmailFailure({ error: error.message })),
                    ),
                ),
            ),
        ),
    )
}
